import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./reset.css";
import "./util.css";
import "./index.css";
// components
import AppHeader from "./components/header/AppHeader";
import ApplicationForm from "./components/form/ApplicationForm";
import CompletePage from "./pages/CompletePage";
import * as Sentry from "@sentry/react";

function FallbackComponent() {
  return <div>An error has occurred</div>;
}

function App() {
  return (
    <div className="main">
      <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
        <Router>
          <Switch>
            {/* If the current URL is /about, this route is rendered
            while the rest are ignored */}
            <Route exact path="/">
              <AppHeader></AppHeader>
              <ApplicationForm></ApplicationForm>
              {/* <div className="py-4 px-8">
                현재 이용중인 서버의 일일 데이터 사용량 초과로 오늘은 쿠폰
                발급이 어렵습니다. 2/23(화) 오후 9시부터 사용하실 수 있습니다.
              </div> */}
            </Route>
            {/* NOTE: 권한이 없는 경우 아래 URL로 접근하면 기본 라우트로 이동 */}
            <Route path="/complete">
              <CompletePage></CompletePage>
            </Route>
          </Switch>
        </Router>
      </Sentry.ErrorBoundary>
    </div>
  );
}

export default App;
